import { Container } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import { ContactDetails } from "./ContactDetails";
import { Logo } from "./Logo";
import { SubHeader } from "./SubHeader";
import type { HeaderProps } from "./types";
import "./Header.css";

export const Header = ({
  className,
  poweredBySb = false,
  url,
  phoneNumber,
  openingHours,
  supportUrl,
  openingHoursLabel,
  componentName,
  partnerSubHeader,
  partnerSubHeaderText,
  partnerName,
  productTitle,
  ...otherProps
}: WithMetadata<HeaderProps>) => {
  const classes = classNames("mobius", "mobius-header", className);
  const { variant } = otherProps;

  return (
    <header
      className={classes}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
    >
      <div className="mobius-header__container">
        <Container size="sm" className="mobius-header__content">
          <Logo url={url} poweredBySb={poweredBySb} />
          {productTitle && (
            <span className="mobius-header__product-title">{productTitle}</span>
          )}
          <ContactDetails
            phoneNumber={phoneNumber}
            poweredBySb={poweredBySb}
            openingHours={openingHours}
            supportUrl={supportUrl}
            openingHoursLabel={openingHoursLabel}
          />
        </Container>
      </div>
      {partnerSubHeader && (
        <SubHeader
          partnerSubHeaderText={partnerSubHeaderText}
          partnerName={partnerName}
        />
      )}
    </header>
  );
};
